var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"3"}},[_c('CrmProfile')],1),_c('b-col',{staticClass:"content-section",attrs:{"cols":"12","lg":"9"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }